import React from 'react'

export default ({ menuButtons }) => (
  <div className="section columns is-multiline">
    {menuButtons.map((button, index) => (
      <div className="column is-3" key={index}>
        {button}
      </div>
    ))}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/templates/main-menu/MainMenuLayout.js